import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-navy font-sans text-ink antialiased" data-id="element-0" data-mp="3ikr002qv3a7b">
      <MetaPixel data-id="element-1" data-mp="3ml17jjuay8oa" />
      <main data-id="element-2" data-mp="3mkhofzsx1e8o">
        <Hero data-id="element-3" data-mp="3mjzuj9tq7c3x" />
        <Testimonials data-id="element-4" data-mp="3mjg9hk8s47lo" />
        <ProblemSection data-id="element-5" data-mp="3rc9ca2kot5v4" />
        <SystemSection data-id="element-6" data-mp="3rbzlwdvqcwow" />
        <ModulesSection data-id="element-7" data-mp="3rdkkqfp2v1sk" />
        <BonusSection data-id="element-8" data-mp="3reccfffk0fdk" />
        <UrgencySection data-id="element-9" data-mp="5ot150vj28n" />
        <PricingSection data-id="element-10" data-mp="682dxcgkib2" />
        <MoreResults data-id="element-11" data-mp="5gg5d4r3wxg" />
        <GuaranteeSection data-id="element-12" data-mp="82ohezguggq" />
        <FAQ data-id="element-13" data-mp="2zld4hgdhhrep" />
        <ClosingSection data-id="element-14" data-mp="2zlv84y2h77wn" />
        <SummaryTable data-id="element-15" data-mp="2zmo557bmuj1l" />
        <FinalCta data-id="element-16" data-mp="2zn6cayzu2hoa" />
      </main>
      <Footer data-id="element-17" data-mp="33mf6g4yschkd" />
      <PurchaseNotification data-id="element-18" data-mp="33lx02fiesmyq" />
    </div>;
}